import { Component } from 'react';
import { connect } from 'react-redux';
import Datatable from '../../../../components/common/datatable/index';
import { history } from '../../../../store';
import { checkPermission } from '../../../common/guards/can';
import ArrowButton from '../../../common/button-arrow';
import { isAbmLoggedIn } from '../../../../utils/tokenUtils';
import { weekOfSaleDate } from '../../../../utils/commonFunctions';

class PipEposSubmissionsTable extends Component {
  render() {
    const {
      currentPage,
      paging,
      pipEposSubmissions,
      onHandlePageChange: onPageChange
    } = this.props;
    const hasEditPipEposSubmissionPermission = checkPermission('manage', 'PipEposSubmission');
    const abmLoggedIn = isAbmLoggedIn();
    const columns = [
      {
        prop: 'customer-number',
        title: 'Outlet code'
      },
      {
        prop: 'sku-code',
        title: 'SKU code'
      },
      {
        prop: 'week-of-sale',
        title: 'Week of Sale',
        width: 310,
        format(name) {
          return (weekOfSaleDate(name));
        }
      },
      {
        prop: 'status',
        title: 'Status'
      },
      {
        prop: 'rdr-code',
        title: 'RDR'
      },
      {
        prop: 'abm-code',
        title: 'ABM'
      }
    ];
    const actions = [
      (index, row) => (
        <ArrowButton
          arrow={false}
          className="red-ghost-btn btn btn-default"
          onClick={() => history.push(abmLoggedIn ? `/team/pip_epos_submissions/${row.id}` : `/admin/pip_epos_submissions/${row.id}`)}
        >
          {hasEditPipEposSubmissionPermission ? 'View/Edit' : 'View'}
        </ArrowButton>
      )
    ];

    return (
      <div>
        <div className="mg-bottom-30"></div>
        <Datatable
          hideId={false}
          data={pipEposSubmissions}
          columns={columns}
          actions={actions}
          remote
          dataSize={paging ? paging.number * paging.size : pipEposSubmissions.length}
          pagination={{
            page: currentPage,
            sizePerPage: 20,
            onPageChange
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  pipEposSubmissions: state.pipEposSubmissions.pipEposSubmissions,
  paging: state.pipEposSubmissions.paging,
});

export default connect(mapStateToProps)(PipEposSubmissionsTable);
